module.exports = __webpack_public_path__ + "static/media/detail-pemesanan.2e26dd18.svg";